import React from 'react';

import type {AlertProps} from '@/modules/finkn/components/alert';
import {Alert} from '@/modules/finkn/components/alert';
import {type ContainerSpacing} from '@/modules/foundation/components/container';
import type {ContentBlockContainerProps} from '@/modules/page/components/content-blocks/block-container';
import {ContentBlockContainer} from '@/modules/page/components/content-blocks/block-container';

type Props = AlertProps &
	ContentBlockContainerProps & {
		spacingBottom?: ContainerSpacing;
		spacingTop?: ContainerSpacing;
		insideToc?: boolean;
	};

export const Banner = ({title, children, severity, options, insideToc}: Props) => {
	return (
		<ContentBlockContainer
			options={options}
			width={options?.fullWidth ? 'screen' : (options?.width ?? 'text')}
			insideToc={insideToc}
		>
			<Alert title={title} severity={severity}>
				{children}
			</Alert>
		</ContentBlockContainer>
	);
};
